import { generate } from '@core/js/utils/componentUtils';
import { fireGATrackingEvent } from '@core/js/utils/analyticsUtils';
import { bindOnPopStateEvent } from '@core/js/utils/browserUtils';
import { closeModal } from '@core/js/utils/modalUtils';
import { removeHash } from '@core/js/utils/routerUtils';

import template from 'modal/bopis-restricted-modal.j2';

function firstRender(store) {
    this.render(store, this);

    fireGATrackingEvent(store, 'restricted item modal', 'open');
}

export function init(store, overrides = {}) {
    const config = {
        attachEvents: attachEvents,
        name: 'modal.bopis-restricted',
        replace: 'once',
        firstRender: firstRender,
        template: template,
        afterCloseAction: afterCloseAction
    };
    return generate(config, store, overrides);
}

function afterCloseAction() {
    // Remove hash and push state on close
    removeHash();
}

function attachEvents() {
    // Close modal on back-button
    bindOnPopStateEvent(this, (e) => {
        closeModal(this, e);
    });
}
